import type { PercentileKey } from '@/features/forecasts/types';

export const FORECAST_PERCENTILE_KEYS: PercentileKey[] = ['p10', 'p20', 'p30', 'p50', 'p70', 'p80', 'p90'];

export const FORECAST_PERCENTILE_VALUES: Record<PercentileKey, number> = {
  p10: 10,
  p20: 20,
  p30: 30,
  p50: 50,
  p70: 70,
  p80: 80,
  p90: 90,
};

export const FORECAST_PERCENTILE_COLORS: Record<PercentileKey, string> = {
  p10: '#14532d',
  p20: '#16a34a',
  p30: '#22c55e',
  p50: '#65a30d',
  p70: '#84cc16',
  p80: '#a3e635',
  p90: '#bef264',
};

export const FORECAST_PERCENTILE_LABELS: Record<PercentileKey, string> = {
  p10: '10',
  p20: '20',
  p30: '30',
  p50: '50',
  p70: '70',
  p80: '80',
  p90: '90',
};
